import { useTranslations } from 'next-intl';
import Text from '@atoms/Text/Text';
import { useMediaQuery } from 'react-responsive';
import Config from '@config';
import { AxfoodTimeSlotViewModel } from '@occ/api-client';
import {
  StyledDetailsItem,
  StyledDetailsItemsContainer,
  StyledDetailsItemTextWrapper,
  StyledDetailsWrapper,
} from './TimeSlotDetails.styles';

export interface Props {
  slot: AxfoodTimeSlotViewModel;
}

const TimeSlotDetails = ({ slot }: Props) => {
  const t = useTranslations('timeSlotDetails');
  const isMobile = useMediaQuery({ query: Config.BREAKPOINTS.IS_MOBILE });
  const { expressSlot, pickingCost, deliveryCost, pickUpExternalLocationCost, pickUpCost, totalCost } = slot;
  const showExternalCost = pickUpExternalLocationCost?.value && pickUpExternalLocationCost?.value > 0;

  return (
    <StyledDetailsWrapper>
      <StyledDetailsItemsContainer className="details-items-container">
        <StyledDetailsItem>
          <StyledDetailsItemTextWrapper data-testid="picking-fee">
            <Text type="detail">{t('pickingFee')}</Text>
            <Text type="subhead" size="small">{`${pickingCost?.value} ${t('currency')}`}</Text>
          </StyledDetailsItemTextWrapper>
        </StyledDetailsItem>

        <StyledDetailsItem>
          <StyledDetailsItemTextWrapper data-testid="delivery-fee">
            <Text type="detail">{isMobile ? t('deliveryFeeShort') : t('deliveryFee')}</Text>
            <Text type="subhead" size="small">{`${deliveryCost?.value} ${t('currency')}`}</Text>
          </StyledDetailsItemTextWrapper>
        </StyledDetailsItem>

        <StyledDetailsItem>
          {showExternalCost ? (
            <StyledDetailsItemTextWrapper data-testid="external-fee">
              <Text type="detail">{isMobile ? t('externalFeeShort') : t('externalFee')}</Text>
              <Text type="subhead" size="small">{`${pickUpExternalLocationCost && pickUpExternalLocationCost.value} ${t(
                'currency'
              )}`}</Text>
            </StyledDetailsItemTextWrapper>
          ) : (
            expressSlot && (
              <StyledDetailsItemTextWrapper data-testid="express-fee">
                <Text type="detail">{isMobile ? t('expressFeeShort') : t('expressFee')}</Text>
                <Text type="subhead" size="small">
                  {`${pickUpCost?.value} ${t('currency')}`}
                </Text>
              </StyledDetailsItemTextWrapper>
            )
          )}
        </StyledDetailsItem>

        <StyledDetailsItem>
          <StyledDetailsItemTextWrapper data-testid="total-cost">
            <Text type="detail">{t('total')}</Text>
            <Text type="subhead" size="small">{`${totalCost?.value} ${t('currency')}`}</Text>
          </StyledDetailsItemTextWrapper>
        </StyledDetailsItem>
      </StyledDetailsItemsContainer>
    </StyledDetailsWrapper>
  );
};

export default TimeSlotDetails;
